import React from 'react';
import { ToastsContainer } from '@/components/ToastsContainer';
import HeroLayout from '@/components/shared/hero/HeroLayout';
import { useSelector } from 'react-redux';
import { selectPromotionWidgets } from '@/store/cms/promotions/selectors';
import PromotionsStreamline from '@/components/shared/promotions-streamline/PromotionsStreamline';
import classNames from 'classnames';
import { selectAvailableBonuses } from '@/store/bonuses/selectors';
import HomeHeroPopularGames from '@/pages/home/hero/HomeHeroPopularGames';
import { envIsSweden } from '@/constants/constants';
import { HeroBankingLogos } from '@/components/HeroBankingLogos';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { envIsCanada } from '@/constants/constants';
import { useRestrictedMode } from '@/hooks/useRestrictedMode';

const HomeHeroContainer = ({
  children,
  isAuthenticated,
}: {
  children: React.ReactNode;
  isAuthenticated: boolean;
}): JSX.Element => {
  const promotions = useSelector(selectPromotionWidgets);
  const locale = useSelector(selectLocale);
  const availableBonuses = useSelector(selectAvailableBonuses);
  const isRestricted = useRestrictedMode();

  return (
    <HeroLayout isAuthenticated={isAuthenticated}>
      <ToastsContainer />
      <div
        className={classNames(
          'z-[10] flex w-full justify-center',
          !envIsCanada() ? ' mt-12 md:mt-32' : '',
        )}
      >
        {children}
      </div>
      {promotions && (
        <div
          className={classNames('py-4 px-4 md:px-8 overflow-hidden mt-4 md:mt-12 max-w-full', {
            'mb-5': availableBonuses.length > 0,
          })}
        >
          <HomeHeroPopularGames />
          {envIsSweden() && <HeroBankingLogos locale={locale} />}
          {/* Promotions are removed in restricted mode — hide the hero promotions streamline. */}
          {!isRestricted && <PromotionsStreamline promotions={promotions} />}
        </div>
      )}
    </HeroLayout>
  );
};

export default HomeHeroContainer;
